import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportMetricService } from '../../services/report-metric.service';
import { ReportFilter } from '../../models/ReportFilter';
import { SimpleAggregate } from '../../models/SimpleAggregate';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  imports: [CommonModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
})
export class DashboardComponent implements OnInit {
  loading = true;
  error = false;

  filter: ReportFilter = {
    siteId: '',
    varietyId: '',
    waveId: '',
    startDate: '',
    endDate: '',
  };

  productionPerSite: SimpleAggregate[] = [];
  productionPerWave: SimpleAggregate[] = [];
  productionPerVariety: SimpleAggregate[] = [];

  transferInPerSite: SimpleAggregate[] = [];
  transferOutPerSite: SimpleAggregate[] = [];
  transferInPerVariety: SimpleAggregate[] = [];
  transferOutPerVariety: SimpleAggregate[] = [];

  totalCards = [
    { label: 'Production totale', value: 0, icon: 'fa-solid fa-industry', color: '#102c57' },
    { label: 'Transferts totaux', value: 0, icon: 'fa-solid fa-right-left', color: '#102c57' },
    { label: 'Total delinte', value: 0, icon: 'fa-solid fa-check-circle', color: '#102c57' },
    { label: 'Total delintage', value: 0, icon: 'fa-solid fa-scissors', color: '#102c57' },
  ];

  aggregateSections: { title: string; data: SimpleAggregate[] }[] = [];

  reportMetricService = inject(ReportMetricService);

  ngOnInit(): void {
    forkJoin({
      perSite: this.reportMetricService.getTotalProductionPerSite(this.filter),
      perWave: this.reportMetricService.getTotalProductionPerWave(this.filter),
      perVariety: this.reportMetricService.getTotalProductionPerVariety(this.filter),
      totalProduction: this.reportMetricService.getTotalProductionAllSites(this.filter),
      totalTransfers: this.reportMetricService.getTotalTransfersAllSites(this.filter),
      totalDelinted: this.reportMetricService.getTotalDelintedAllSites(this.filter),
      totalDelintage: this.reportMetricService.getTotalDelintageAllSites(this.filter),
      transferInPerSite: this.reportMetricService.getTotalTransferInPerSite(this.filter),
      transferOutPerSite: this.reportMetricService.getTotalTransferOutPerSite(this.filter),
      transferInPerVariety: this.reportMetricService.getTotalTransferInPerVariety(this.filter),
      transferOutPerVariety: this.reportMetricService.getTotalTransferOutPerVariety(this.filter),
    }).subscribe({
      next: (results) => {
        this.totalCards = [
          { label: 'Production totale', value: results.totalProduction, icon: 'fa-solid fa-industry', color: '#102c57' },
          { label: 'Transferts totaux', value: results.totalTransfers, icon: 'fa-solid fa-right-left', color: '#102c57' },
          { label: 'Total delinte', value: results.totalDelinted, icon: 'fa-solid fa-check-circle', color: '#102c57' },
          { label: 'Total delintage', value: results.totalDelintage, icon: 'fa-solid fa-scissors', color: '#102c57' },
        ];

        this.aggregateSections = [
          { title: 'Production par site', data: results.perSite },
          { title: 'Production par vague', data: results.perWave },
          { title: 'Production par variete', data: results.perVariety },
          { title: 'Transfert entrant par site', data: results.transferInPerSite },
          { title: 'Transfert sortant par site', data: results.transferOutPerSite },
          { title: 'Transfert entrant par variete', data: results.transferInPerVariety },
          { title: 'Transfert sortant par variete', data: results.transferOutPerVariety },
        ];

        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      },
    });
  }
}
